import Box from './Box'

export default Box



// WEBPACK FOOTER //
// ./src/components/Box/index.js